import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { get, post } from '../../api/client'
import type { PublicCancel } from '../../api/types'
import { Button, ErrorNote, Spinner } from '../../components/ui'
import { fmtEventWhen } from '../../lib/format'

export function CancelPage() {
  const { token = '' } = useParams()
  const q = useQuery({ queryKey: ['public-cancel', token], queryFn: () => get<PublicCancel>(`/api/public/avanmalan/${token}`), retry: false })
  const [result, setResult] = useState<PublicCancel | null>(null)
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<unknown>(null)

  if (q.isLoading) return <Spinner />
  if (q.isError) return <div className="card p-8 text-center"><h1 className="text-xl">Länken är inte giltig</h1></div>
  const info = result ?? q.data!
  const cancelled = info.status === 'AVANMALD'

  const doCancel = async () => {
    setPending(true)
    try { setResult(await post<PublicCancel>(`/api/public/avanmalan/${token}`)) } catch (e) { setError(e) } finally { setPending(false) }
  }

  return (
    <div className="card p-8 text-center">
      <h1 className="text-xl">{cancelled ? 'Du är avanmäld' : `Avanmälan – ${info.event_name}`}</h1>
      <p className="mt-2 text-sm text-ink-500">
        {cancelled
          ? `Din plats på ${info.event_name} den ${fmtEventWhen(info.starts_at, null)} har frigjorts. Tack för att du meddelade oss.`
          : `Hej ${info.first_name}. Vill du avanmäla dig från ${info.event_name} den ${fmtEventWhen(info.starts_at, null)}?`}
      </p>
      <ErrorNote error={error} />
      {!cancelled && <Button variant="danger" className="mt-5" loading={pending} onClick={doCancel}>Ja, avanmäl mig</Button>}
    </div>
  )
}
